import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DownloadButton from 'src/components/DownloadButton';
import {
  downloadAccountingCapitalBalanceAction,
  downloadAccountingInterestBalanceAction
} from 'src/store/actions/contractActions';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import useStyles from './styles';

const Toolbar = ({ className, tabIndex = 0, ...rest }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { id } = useParams();

  const handleExcelExport = useCallback(() => {
    if (tabIndex === 0) {
      dispatch(downloadAccountingCapitalBalanceAction(id));
    } else if (tabIndex === 1) {
      dispatch(downloadAccountingInterestBalanceAction(id));
    }
  }, [tabIndex, id]);

  return (
    <Box
      className={className}
      sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}
      {...rest}
    >
      <Box className={classes.actionsContainer} mb={0.5}>
        <DownloadButton
          onDownload={handleExcelExport}
          title={t('COMMON.DOWNLOAD')}
        />
      </Box>
    </Box>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  tabIndex: PropTypes.number
};

export default Toolbar;
